import recordPhraseUsageClient from "@workspace/cms-phrases/src/client/recorder";
import replaceVariables from "@workspace/cms-phrases/src/phrase/replaceVariables";

type Props = {
  id: string;
  translations: Record<string, Maybe<string>>;
  values?: { [key: string]: string | number };
  className?: string;
};

const Translation: FC<Props> = (props) => {
  const translation = getTranslation(props);
  recordPhraseUsageClient(props.id, props.translations[props.id] ?? undefined);
  return (
    <span data-translation={props.id} className={props.className}>
      {translation}
    </span>
  );
};

const getTranslation = ({ id, translations, values }: Props) => {
  const translation = translations[id] ?? id;
  if (!values) {
    return translation;
  }
  return replaceVariables(translation, values);
};

export default Translation;
